<template>
  <article class="pm-summary">
    <div class="pm-summary__label">
      СПОСОБ ОПЛАТЫ
    </div>

    <router-link
      v-if="method"
      class="pm-summary__card"
      :to="{ name: RouteName.BillingPaymentMethods }"
    >
      <card-brand-badge class="pm-summary__brand" :brand="method.cardBrand" />
      <div class="pm-summary__card-info">
        <div class="pm-summary__number">
          {{ maskedNumber }}
        </div>
        <div v-if="expiry" class="pm-summary__expiry">
          Действует до {{ expiry }}
        </div>
      </div>
      <span class="pm-summary__mark">Основная</span>
    </router-link>

    <router-link
      v-else
      class="pm-summary__card pm-summary__card_empty"
      :to="{ name: RouteName.BillingPaymentMethods }"
    >
      <v-icon size="28" color="#949191">
        mdi-credit-card-off-outline
      </v-icon>
      <div class="pm-summary__card-info">
        <div class="pm-summary__number">
          Карта не привязана
        </div>
        <div class="pm-summary__expiry">
          Привяжите карту, чтобы платить за тариф без напоминаний
        </div>
      </div>
    </router-link>

    <div class="pm-summary__autopay">
      <div class="pm-summary__autopay-row">
        <div class="pm-summary__autopay-title">
          Автопополнение
        </div>
        <v-switch
          :input-value="autopayEnabled"
          :disabled="!canToggle || !canUseBilling"
          :loading="updating"
          class="pm-summary__switch"
          color="#4caf50"
          inset
          dense
          hide-details
          @change="$emit('toggle-autopay', $event)"
        />
      </div>
      <div class="pm-summary__autopay-hint">
        {{ autopayHint }}
      </div>
    </div>
  </article>
</template>

<script>
  import RouteName from '@/models/enums/RouteName'
  import CardBrandBadge from '@/components/billing/CardBrandBadge.vue'

  export default {
    name: 'PaymentMethodSummary',
    components: { CardBrandBadge },
    props: {
      method: {
        type: Object,
        default: null,
      },
      canManage: {
        type: Boolean,
        default: false,
      },
      updating: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      RouteName () {
        return RouteName
      },
      maskedNumber () {
        return this.method && this.method.last4
          ? `•••• •••• •••• ${this.method.last4}`
          : '•••• •••• •••• ••••'
      },
      expiry () {
        if (!this.method || !this.method.expMonth || !this.method.expYear) return null
        const mm = String(this.method.expMonth).padStart(2, '0')
        const yy = String(this.method.expYear).slice(-2)
        return `${mm} / ${yy}`
      },
      autopayEnabled () {
        return !!this.method && !!this.method.autopayEnabled
      },
      canToggle () {
        return this.canManage && !!this.method && !!this.method.isActive
      },
      autopayHint () {
        if (!this.method) return 'Без карты автосписание за тариф не работает'
        if (!this.method.isActive) return 'Карта отключена — включите её в способах оплаты'
        return this.autopayEnabled
          ? `Спишется с карты •••• ${this.method.last4} · чек придёт на почту`
          : 'Баланс придётся пополнять вручную'
      },
    },
  }
</script>

<style lang="less" scoped>
.pm-summary {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border: 1px solid #c4cdd9;
  border-radius: 5px;
  padding: 24px;

  .media-xs({
    padding: 20px 16px;
  });

  &__label {
    font-size: 11px;
    color: #757575;
    letter-spacing: 0.4px;
  }

  &__card {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-top: 14px;
    background-color: @color-secondary;
    border-radius: 6px;
    padding: 14px 16px;
    text-decoration: none;

    &_empty {
      background-color: #fff3d6;
    }
  }

  &__brand {
    flex: 0 0 auto;
    width: 68px;
    height: 46px;
  }

  &__card-info {
    flex: 1 1 auto;
    min-width: 0;
  }

  &__number {
    font-size: 15px;
    font-weight: 500;
    color: #323030;
  }

  &__expiry {
    margin-top: 4px;
    font-size: 11px;
    color: #757575;
  }

  &__mark {
    flex: 0 0 auto;
    font-size: 11px;
    color: @color-primary;
  }

  &__autopay {
    margin-top: 18px;
  }

  &__autopay-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
  }

  &__autopay-title {
    font-size: 16px;
    font-weight: 700;
    color: #323030;
  }

  &__switch.v-input {
    flex: 0 0 auto;
    margin: 0;
    padding: 0;
  }

  &__autopay-hint {
    margin-top: 6px;
    font-size: 11px;
    color: #999;
  }

  &__why {
    margin-top: auto;
    padding-top: 16px;
    font-size: 11px;
    color: #4caf50;
  }
}
</style>
